export const USERS_PAGE_TITLE = "Users";

export const TABLE_HEADERS = {
  NAME: "Name",
  EMAIL: "Email",
  ROLE: "Role",
  STATUS: "Status",
  ORGANIZATION: "Organization",
  CREATED_AT: "Created At",
};

export const MESSAGES = {
  ERROR: "Failed to load users. Please try again later.",
  EMPTY: "No users found.",
};

export const FILTER_PLACEHOLDER = "Filter users...";
export const ORGANIZATION_FILTER_LABEL = "Filter by organization:";
